import React from "react";
import * as Icon from "react-bootstrap-icons";
const StatusSetter = ({ status }) => {
  return (
    <div>
      {(() => {
        switch (status) {
          case "done":
            return <Icon.CheckSquareFill color="green" size={30} />;
          case "submitted":
            return <Icon.UnlockFill color="black" size={30} />;
          case "cancelled":
            return <Icon.XOctagonFill color="#ad1818" size={30} />;
          case "inProgress":
            return <Icon.LockFill color="#ccc508" size={30} />;
          case "waitingForPayment":
            return <Icon.CashStack color="#ad1818" size={30} />;
          default:
            return (
              <div>
                <Icon.QuestionOctagonFill color="black" size={35} />
              </div>
            );
        }
      })()}
    </div>
  );
};
export default StatusSetter;
